import { createFileRoute, Outlet } from '@tanstack/react-router'
import { TooltipProvider } from '@/components/ui/tooltip'

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    title?: string
  }
}

export const Route = createFileRoute('/_layout')({ component: LayoutRoute })

function LayoutRoute() {
  return (
    <TooltipProvider>
      <div className="h-screen flex flex-col bg-white text-gray-900 overflow-hidden">
        <Outlet />
      </div>
    </TooltipProvider>
  )
}
